import { render } from "./ProfilePopup.vue?vue&type=template&id=4379d456"
import script from "./ProfilePopup.vue?vue&type=script&lang=js"
export * from "./ProfilePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__